import React, { useLayoutEffect } from "react";
import {
  useIsDesktop,
  WSElement,
  WSScreen
} from "@wingspanhq/fe-component-library";
import { SectionInfo } from "../SettingsSectionInfo/SectionInfo.component";
import kebabCase from "lodash/kebabCase";
import { useLocation } from "react-router-dom";

export interface SettingsSectionProps {
  title: string;
  description?: string;
  render(): React.ReactNode;
}

export const SettingsSection: React.FC<SettingsSectionProps> = ({
  title,
  description,
  render
}) => {
  const isDesktop = useIsDesktop();
  const location = useLocation();
  const id = kebabCase(title);

  useLayoutEffect(() => {
    if (isDesktop && location.pathname.endsWith(id)) {
      setTimeout(() => {
        window.document
          .getElementById(id)
          ?.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  }, [location.pathname, isDesktop]);

  return (
    <WSElement mb="XL" id={id}>
      <WSScreen.Desktop>
        <SectionInfo title={title} description={description} />
      </WSScreen.Desktop>
      {render()}
    </WSElement>
  );
};
